export default __webpack_public_path__ + "static/media/yd-wealth.0e05bda6.png";